import { TextField } from "@mui/material";
import MaskedInput from 'react-text-mask';

const PhoneNumberMask = ({ inputRef, ...props }) => (
    <MaskedInput
      {...props}
      mask={[/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
    />
);
    
export const PhoneNumberInput = (props) => {
    const {
        value,
        id,
        label,
        handleKeyDown,
        handleChange
    } = props;

    const removeNonDigits = (value) => {
        return value.replace(/[^0-9]/g, '');
    }
    
    return (
        <TextField
            value={value}
            id={id}
            label={label}
            onKeyDown={handleKeyDown}
            onChange={(e) => handleChange(id, removeNonDigits(e.target.value))}
            InputProps={{
                inputComponent: PhoneNumberMask
            }}
            fullWidth
        />
    )
}
